// --- Collection: infinite scroll con lazy load immagini ---
(function () {
var isLoading = false;
var productList = document.querySelector('.product-list');
var pagination = document.querySelector('.pagination');

function revealNewCards(cards) {
cards.forEach(function (card) {
card.classList.remove('opacity-0', 'hidden');
card.style.opacity = 1;
if (typeof window.theme !== 'undefined' && window.theme.productCardReveal) {
window.theme.productCardReveal(card);
}

var imgs = card.querySelectorAll('img[data-src]');
imgs.forEach(function (img) {
if (!img.src) img.src = img.getAttribute('data-src');
});
});
}

function appendProducts(newProductsHTML) {
var temp = document.createElement('div');
temp.innerHTML = newProductsHTML;
var cards = temp.querySelectorAll('.product-card');
cards.forEach(function (card) {
productList.appendChild(card);
});
revealNewCards(cards);
}

function loadNextPage() {
if (isLoading) return;
var nextLink = document.querySelector('.pagination a[rel="next"]');
if (!nextLink) return;
isLoading = true;

fetch(nextLink.href)
.then(res => res.text())
.then(html => {
var parser = new DOMParser();
var doc = parser.parseFromString(html, 'text/html');
var newProducts = doc.querySelector('.product-list');
var newPagination = doc.querySelector('.pagination');

if (newProducts) appendProducts(newProducts.innerHTML);

if (newPagination) {
pagination.innerHTML = newPagination.innerHTML;
} else if (pagination) {
pagination.style.display = 'none';
}

isLoading = false;
});
}

window.addEventListener('scroll', function () {
if (!productList) return;
var scrollBottom = window.innerHeight + window.scrollY;
var threshold = productList.offsetTop + productList.offsetHeight - 500;
if (scrollBottom >= threshold) loadNextPage();
});

if (pagination) pagination.style.display = 'none';
})();

// --- Collection: testo descrittivo sotto l'h1 del banner ---
document.addEventListener('DOMContentLoaded', function () {
const source = document.getElementById('collection-text-source');
if (!source) return;

const h1 = document.querySelector('collection-banner h1');
if (!h1) return;

const div = document.createElement('div');
div.className = 'collection-text';
div.innerHTML = source.innerHTML.trim();
source.remove();

h1.insertAdjacentElement('afterend', div);
});